import CrudCustom from '../../../libs/custom/CrudCustom';
import http from './../../../libs/custom/httpService.custom';

let ItemService = new CrudCustom('/items');

ItemService.approval = async(data)=> {
    return http.request({
      method: http.methods.PUT,
      url: `/items/status`,
      data
    })
}

ItemService.http = http;

export default ItemService;
